import { CreateReviewPayload, ResolveReviewPayload, Review } from '../types/review';
import { apiFetch } from './api-client';
import { getActiveWorkspaceHeaders } from './workspace-context';

async function parseJson<T>(response: Response): Promise<T> {
  const data = await response.json();
  if (!response.ok) {
    throw new Error((data as { error?: string }).error || 'Request failed');
  }
  return data as T;
}

function reviewHeaders(): Record<string, string> {
  return {
    ...getActiveWorkspaceHeaders(),
  };
}

export async function createReview(payload: CreateReviewPayload): Promise<Review> {
  const response = await apiFetch('/api/reviews', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...reviewHeaders(),
    },
    body: JSON.stringify(payload),
  });
  return parseJson<Review>(response);
}

export async function fetchReviews(
  filters?: { scenario_id?: string; status?: 'open' | 'resolved' }
): Promise<Review[]> {
  const params = new URLSearchParams();
  if (filters?.scenario_id) params.set('scenario_id', filters.scenario_id);
  if (filters?.status) params.set('status', filters.status);
  const query = params.toString();
  const response = await apiFetch(`/api/reviews${query ? `?${query}` : ''}`, {
    headers: reviewHeaders(),
  });
  return parseJson<Review[]>(response);
}

export async function downloadReviewChangelog(
  scenarioId: string,
  from: string,
  to: string
): Promise<void> {
  const params = new URLSearchParams({ from, to });
  const response = await apiFetch(
    `/api/reviews/changelog/${encodeURIComponent(scenarioId)}?${params.toString()}`,
    {
      headers: reviewHeaders(),
    }
  );
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new Error((data as { error?: string }).error || 'Échec du téléchargement');
  }

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${scenarioId}-reviews-changelog-${from}_${to}.md`;
  link.click();
  URL.revokeObjectURL(url);
}

export async function resolveReview(
  id: string,
  payload?: ResolveReviewPayload
): Promise<Review> {
  const response = await apiFetch(`/api/reviews/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      ...reviewHeaders(),
    },
    body: JSON.stringify(payload ?? { status: 'resolved' }),
  });
  return parseJson<Review>(response);
}
